import { useApis } from '@/legacy-src/contexts/api-context'
import type { ApiEndpoints } from '@/legacy-src/services/api'

import { useCart } from '@/src/domains/cart/hooks/useCart'
import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const useCartResolve = <
  Config extends SwrQueryOptions<Awaited<ReturnType<ApiEndpoints['resolveCart']>>['data']> | undefined,
>(
  options?: Config,
) => {
  const { selectedSlots, prebookingIds, voucher, bypassSubscriptionAndCompanyBenefits } = useCart()

  const { api } = useApis()

  return useSwrQuery(
    [{ selectedSlots, prebookingIds, voucher, bypassSubscriptionAndCompanyBenefits }, '/event/cart/resolve', 'POST'],
    async () => {
      const prebookingEvents = prebookingIds.map((id) => ({
        id,
      }))

      const allEvents = [...selectedSlots, ...prebookingEvents]

      if (allEvents.length === 0) {
        return {
          totalPrice: '0',
          vouchers: [],
          events: [],
          generalErrors: [],
          currency: '',
        } satisfies Awaited<ReturnType<typeof api.resolveCart>>['data']
      }

      const { data } = await api.resolveCart({
        bypassSubscriptionAndCompanyBenefits,
        events: allEvents,
        vouchers: voucher
          ? [
              {
                code: voucher,
              },
            ]
          : [],
      })

      return data
    },
    options,
    {
      keepPreviousData: true,
    },
  )
}
